import { get } from '../../utils/http'

export const getDetail = (id) => get(`/xbag/college/university/id/${id}`, {}, true)
export const getList = (param) => get(`/xbag/college/university/gets`, param)
export const getCategory = (type = 4, parentId = 0) => get(`/xbag/college/category/${type}/${parentId}/gets`, {}, true)
export const getProvince = () => get(`/xbag/area/province/gets`, {}, true)
export const getScore = (provinceId,branch) => get(`/xbag/college/score/ranking/list`, {provinceId,branch}, true)
export const getSpecialtiesByUniversityId = (universityId) => get(`/xbag/college/specialty/gets/${universityId}`, {}, true)
// export const getSchoolScoreList = (universityId,provinceId,branchCode,batchCode) => get(`/xbag/college/score/university/${universityId}/${provinceId}/${branchCode}/${batchCode}`, {}, true)
export const getSchoolScoreList = (universityId,provinceId) => get(`/xbag/college/score/university/${universityId}/${provinceId}`, {}, false)

export const setSessionData = function (data, value) {
    window.sessionStorage.setItem(data, JSON.stringify(value));
    // console.log('set', window.localStorage.getItem(data));
    return;
};
export const delSessionData = function (data) {
    window.sessionStorage.removeItem(data);
    // console.log('del', window.localStorage.getItem(data));
    return;
};
export const getSessionData = function (data, isRemoveFlag = false) {
    const value = JSON.parse(window.sessionStorage.getItem(data));
    // console.log('get', window.localStorage.getItem(data))
    if (value === 'undefined') {
        delSessionData(data);
        return;
    }
    isRemoveFlag && delSessionData(data);
    return value
};

export const getLocalData = function (data, isRemoveFlag = false) {
    const value =JSON.parse( window.localStorage.getItem(data));
    // console.log('get', window.localStorage.getItem(data))
    if (value === 'undefined') {
        delLocalData(data);
        return;
    }
    isRemoveFlag && delLocalData(data);
    return value
};

export const delLocalData = function (data) {
    window.localStorage.removeItem(data);
    // console.log('del', window.localStorage.getItem(data));
    return;
};

export const setLocalData = function (data, value) {
    window.localStorage.setItem(data, JSON.stringify(value));
    // console.log('set', window.localStorage.getItem(data));
    return;
};



// WEBPACK FOOTER //
// ./src/api/school/index.js